import { yup } from '@/libs/yup';

export type Schema = {
  file?: File;
};

export const schema = yup.object({
  file: yup.mixed<File>().label('ファイル')
});
